import React, { useEffect, useState, memo } from "react";
import { WebService } from "../../Services/WebService";
import "../Company/Company.css";
import { ActionPermission, PageInfo } from "../PageInfo";
import "../Company/Company.css";
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import TopbarComponent from "../../Services/TopbarComponent";

import { useDispatch, useSelector } from "react-redux";
import { AppBar, Box, Button, Tab, Tabs, useTheme } from "@mui/material";
import {  Grain, Insights, Leaderboard, WaterfallChart } from "@mui/icons-material";

import ShiftLineChart from "./Reports/ShiftLineChart";

import FilterableViewComponent from "./FilterableViewComponent";
import { DateTime } from "luxon";
import AppbarComponent from "../../Services/AppbarComponent";
import { Container } from "react-bootstrap";

const ReportMasterPage = () => {
  PageInfo({ pageTitle: "Shift Timing" });
  const [records, setRecords] = useState([]);
  const dispatch = useDispatch();
  const [data,setdata]= useState({});
  const MasterPageName='Shift Report'


  const [filters, setFilters] = useState({
    FromTime: "",
    ToTime: "",
    OfficeLocationId: "",
  });
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [value, setValue] = useState(0);
  const [ReportType,setReportType] = useState(['early-CheckIn'])
   const [filter, setFilter] = useState({
      FromDate: DateTime.local().toFormat("yyyy-MM-dd"),
      ToDate: DateTime.local().toFormat("yyyy-MM-dd"),
    });
  
 const theme = useTheme();

 useEffect(()=>{
  getReportData()
 },[value])
  
 
  const fetchdata = async () => {
    const data = await WebService({
      endPoint: `ShiftTiming/fetch`,
      method: "post",
      body: {
        page,
        limit,
        filters,
      },
      dispatch,
    });
    setRecords(data.data);
    setTotal(data.total);
  };
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const [permission, setPermission] = useState({});
  useEffect(() => {
    setPermission({
      ManageAdd: ActionPermission("Shift Timing Add"),
      ManageEdit: ActionPermission("Shift Timing Edit"),
      ManageDelete: ActionPermission("Shift Timing View"),
      ManageView: ActionPermission("Shift Timing Delete"),
      // ManageDelete: ActionPermission("Roles - Delete"),
    });
  }, [permissionList]);

     const [bData] = useState([
          {
              title: "Recruitment",
              hrefLink: "/RecruiterDashboard",
          },
          {
              title: "Jobs",
              hrefLink: "#",
          },
      ]);

      function TabPanel(props) {
        const { children, value, index, ...other } = props;
    
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ p: 0, mt: 0 }}>
                <span>{children}</span>
              </Box>
            )}
          </div>
        );
      }   

      const handleChangeIndex = (index) => {
        setValue(index);
      };
      const handleChange = (event, newValue) => {
        setReportType([event.target.name])
        setValue(newValue);
      };


      // get graph data for backend
      const getReportData = async () => {
        const reportType = ReportType;
        const response = await WebService({
          endPoint: `ShiftTiming/ShiftReports`,
          method: 'post',
          body: { filter, reportType },
          dispatch
        });
      
        // Prevent unnecessary re-renders
        setdata((prev) => {
          const isSame = JSON.stringify(prev) === JSON.stringify(response.data);
          return isSame ? prev : response.data;
        });
      };
      

  return (
    <div className=" w-100">
      <TopbarComponent bData={bData} HeadingText={MasterPageName} />
      
      
      <FilterableViewComponent setFilter={setFilter} filter={filter}/>


      <Box>
        <AppBar
          position="static"
          color="info"
          elevation={0}
          className="Maintab_Custome mb-2"
          style={{ maxHeight: "40px", height: "40px" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            style={{
              maxHeight: "40px",
              height: "40px",
            }}
            id="tabs"
          >
            <Tab
              icon={<Insights />}
              aria-label="person"
              label="Early Check In"
              name = "early-CheckIn"
              iconPosition="start"
              className="tab_Custome pt-0"
              id="pending"
            />
            <Tab
              icon={<Leaderboard />}
              aria-label="phone"
              label="Early Check out"
              name='early-CheckOut'
              iconPosition="start"
              className="tab_Custome pt-0"
              id="approved"
            />
            <Tab
              icon={<WaterfallChart />}
              aria-label="favorite"
              label="late-CheckIn"
              name = "late-CheckIn"
              iconPosition="start"
              className="tab_Custome pt-0"
              id="rejected"
            />
            <Tab
              icon={<Grain />}
              aria-label="favorite"
              label="late-CheckOut"
              name = "late-CheckOut"
              iconPosition="start"
              className="tab_Custome pt-0"
              id="rejected"
            />
          </Tabs>
        </AppBar>
      </Box>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {" "}
         <ShiftLineChart data={data}/>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {" "}
          <ShiftLineChart data={data}/>
          </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          {" "}
          <ShiftLineChart data={data}/>
          </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          {" "}
          <ShiftLineChart data={data}/>
          </TabPanel>
      </SwipeableViews>
    </div>
  );
};

export default memo(ReportMasterPage);


